export default __webpack_public_path__ + "static/media/app-screens-v2-67-2_07.55c7de33.jpg";